// extracted by mini-css-extract-plugin
export default {"headerBar":"cJ-z","pointsSection":"dJ-z","goToDashboard":"eJ-z"};